<template>
    <div id="app">
        <router-view />
    </div>
</template>

<script>
import { mapMutations, mapActions } from 'vuex'
import { getUrlParam, removeItem, setItem, setCookie } from './utils'
import SessionUtil from './utils/SessionUtil'
import { createPlatFormScript } from './utils/platform'

export default {
    name: 'app',

    mounted() {
        // this.getUrlQuery()
        createPlatFormScript()
        this.init()
    },

    methods: {
        ...mapMutations([
            'updateStateData',
            'updateRootStateData'
        ]),
        ...mapActions({
            setUserInfo: 'getUserInfo'
        }),
        async init() {
            const [token, appName] = [
                getUrlParam('token'),
                getUrlParam('appName')
            ]
            if (token || appName) {
                this.updateRootStateData({ key: 'sso_sessionid', value: token })
                this.updateRootStateData({ key: 'appName', value: appName })
                await this.setUserInfo()
            }
        },
        /**
         * 获取url 上 参数 并保存到本地session
         */
        getUrlQuery() {
            let sessionId = getUrlParam('sessionId')
                ? getUrlParam('sessionId')
                : getUrlParam('sessionid')
            sessionId = decodeURIComponent(sessionId)
            const [
                clientType,
                systemType,
                user_openid,
                appName,
                platform,
                entranceAppname = ''
            ] = [
                getUrlParam('clientType'),
                getUrlParam('systemType'),
                getUrlParam('user_openid'),
                getUrlParam('appName'),
                getUrlParam('platform'),
                getUrlParam('entranceAppname')
            ]
            const info = { sessionId, clientType, systemType }
            this.REFRESH_USER_PLATFORM({ platform: appName || platform })
            this.REFRESH_USER_OPEN_ID(user_openid)
            if (this.isBytedance) {
                // 如果是字节跳动小程序，更新是那个端口进来的
                this.REFRESH_ENTRANCE_APPNAME(entranceAppname)
            }
            removeItem('sessionid')
            // 保存参数
            if (sessionId && sessionId !== 'null') {
                setItem('sessionid', sessionId)
                this.updateStateData({ key: 'sessionId', value: sessionId })
                SessionUtil.setAppEnv(info)
                setCookie('sso_sessionid', sessionId)
                this.REFRESH_USER_ID(sessionId)
                this.setUserInfo() // 设置用户信息
                this.setShopInfo() // 设置用户票数相关
            }
        }
    }
}
</script>

<style lang="scss">
#app {
    width: 100%;
    height: 100%;
}
@import './assets/css/app.scss';
</style>
